import 'slick-carousel';

export default class Testimonials {

    rightArrowEl = '.b-testimonials__controls-button--right';
    leftArrowEl = '.b-testimonials__controls-button--left';
    textEl = '.b-testimonials__slide-text';

    init = (node) => {

        const text = $(this.textEl).text;

        node.slick({
            nextArrow: $(this.rightArrowEl),
            prevArrow: $(this.leftArrowEl),
            infinite: false,
            dots: false
        });
    }

    toggleText = () => {
        if (this.text.hasClass('collapsed')){
            this.text.removeClass('collapsed');
        }else {
            this.text.addClass('collapsed');
        }
    }

    constructor(node) {
        this.node = $(node);
        this.text = $(this.textEl);

        this.text.on('click', this.toggleText);
        this.text.addClass('collapsed');

        this.init(this.node);
    }
}



// WEBPACK FOOTER //
// ./app/blocks/testimonials/testimonials.js